import { ActionCreator } from '@wix/restaurants-client-logic';

export function createAction<Payload = void>(type: string): ActionCreator<Payload> {
  const action: ActionCreator<Payload> = (payload: Payload) => ({ type, payload });

  action.toString = () => type;

  return action;
}
